(function () {
    "use strict";

    /**
     * INSPINIA - Responsive Admin Theme
     *
     */
    const app = angular.module("dashboard", [
        "ui.router",                                            // Routing
        "ui.bootstrap",                                         // Bootstrap
        "ngAnimate",                                            // Bootstrap Animations
        "ngSanitize",
        "ui.select",
        "datatables", "datatables.buttons",                      // http://l-lin.github.io/angular-datatables
        "ya.nouislider",
        "ng.ckeditor",
        "ngTable",
        "angularMoment",
        "angularjs-dropdown-multiselect",                    // https://github.com/dotansimha/angularjs-dropdown-multiselect
        "angular.chosen",
        "ngSegment",
        "html5Sortable"
    ]);

    app.config(["segmentProvider", "DashboardConfig", function (segmentProvider, DashboardConfig) {
        if (DashboardConfig.AnalyticsKey) {
            segmentProvider.setKey(DashboardConfig.AnalyticsKey);
        }
    }]);

    app.run(function (DTDefaultOptions) {
        DTDefaultOptions.setLoadingTemplate("<div class=\"table-loader\">Loading...</div>");
    });

    app.run(function ($rootScope, $location, $window, $transitions) {
        $transitions.onSuccess({}, function (transition) {
            const state = transition.to();
            $window.dataLayer = $window.dataLayer || [];
            $window.dataLayer.push({
                "event": "pageview",
                "host": $location.host(),
                "url": $location.url(),
                "title": state.title || $rootScope.heading
            });
        });
    });

    app.run([
        "$transitions",
        "$location",
        "$timeout",
        "$rootScope",
        "AnalyticsService",
        ($transitions,
         $location,
         $timeout,
         $rootScope,
         AnalyticsService
        ) => {
            $transitions.onSuccess({}, (transition) => {
                const state = transition.to();
                const title = state.title || $rootScope.heading;
                $rootScope.heading = title;
                $timeout(() => {
                    if (!title) {
                        return;
                    }
                    AnalyticsService.page(title, {
                        url: $location.absUrl(),
                        path: $location.url()
                    });
                });
            });
        } ])

    app.run([
        '$rootScope',
        'DashboardConfig',
        ($rootScope,
         DashboardConfig,
        ) => {
        $rootScope.baseHref = DashboardConfig.BaseHref;
        _.datatables.renderer.configureCurrencySymbol(DashboardConfig.CurrencySymbol);
    }]);

    app.run(function ($templateRequest) {
        $templateRequest("components/store/order-up/order-up-disconnected-modal.22705a1a.html");
    });

// Global http handler - catches 401 HttpStatusCodes
    app.config([ "$httpProvider", function ($httpProvider) {
        const interceptor = [
            "$rootScope",
            "$q",
            "LoaderService",
            "DashboardConfig",
            function httpInterceptor(
                $rootScope,
                $q,
                LoaderService,
                DashboardConfig
            ) {
                return {
                    /**
                     * Fires before any $http request
                     * @param config
                     * @returns {object}
                     */
                    "request": function (config) {
                        if (!config.showLoader) {
                            config.showLoader = true;
                        }
                        if (config.showLoader) {
                            LoaderService.showLoader();
                        }

                        return config;
                    },

                    /**
                     * Intercepts all $http AJAX request errors
                     * @param rejection
                     * @returns {Promise}
                     */
                    "requestError": function (rejection) {
                        // do something on error
                        if (rejection.config.showLoader) {
                            LoaderService.hideLoader();
                        }
                        return $q.reject(rejection);
                    },

                    /**
                     * Intecepts all $http AJAX responses
                     * @param response
                     * @returns {object}
                     */
                    "response": function (response) {
                        // do something on success
                        if (response.config.showLoader) {
                            LoaderService.hideLoader();
                        }
                        return response;
                    },

                    /**
                     * Intercepts all $http AJAX response errors
                     * @param rejection
                     * @returns {Promise}
                     */
                    "responseError": function (rejection) {
                        if (rejection.config.showLoader) {
                            LoaderService.hideLoader();
                        }

                        const endTime = new Date().getTime();
                        const defer = $q.defer();
                        if (rejection.status === Dashboard.HttpStatusCodes.Unauthorized) {
                            // Redirect to Yumbi Login page
                            if ($rootScope.$state.current.name !== "signin") {
                                $rootScope.$state.go("signin", { returnUrl: window.location });
                            }
                        } else if (rejection.status === Dashboard.HttpStatusCodes.NetworkError) {
                            // Try and determine what went wrong
                            if (endTime - rejection.config.startTime >= DashboardConfig.HttpTimeout) {
                                rejection.isTimeOut = true;
                            }
                        }
                        defer.reject(rejection);
                        return defer.promise;
                    }
                };
            } ];

        $httpProvider.interceptors.push(interceptor);

    } ]);
})();
